import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
interface InterventionTimerProps {
  startTime: Date;
}
export function InterventionTimer({
  startTime
}: InterventionTimerProps) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const diff = Math.floor((now.getTime() - startTime.getTime()) / 1000);
      setElapsed(diff);
    }, 1000);
    return () => clearInterval(interval);
  }, [startTime]);
  const formatTime = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const secs = totalSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };
  return <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200" data-id="element-158">
      <div className="flex items-center justify-between" data-id="element-159">
        <div className="flex items-center gap-4" data-id="element-160">
          <div className="w-14 h-14 rounded-full bg-teal-50 flex items-center justify-center" data-id="element-161">
            <Clock className="w-7 h-7 text-teal-deep" data-id="element-162" />
          </div>
          <div data-id="element-163">
            <p className="text-base font-medium text-gray-500 mb-1" data-id="element-164">
              Tempo Intervento
            </p>
            <motion.p key={elapsed} initial={{
            scale: 1.05
          }} animate={{
            scale: 1
          }} className="text-4xl font-bold text-navy font-mono" data-id="element-165">
              {formatTime(elapsed)}
            </motion.p>
          </div>
        </div>
      </div>
    </div>;
}